import { Component, inject, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FirebaseService } from '../services/firebase/firebase.service';
import { SharedService } from '../services/rock/shared.service';
import { AllTestResults, MinistryArea, SpiritualGiftScore } from '../services/spiritual-gifts/spiritual-gifts.service';

import ConnectionGroups from '../gifts-assessment/ConnectionGroups.json';
import Ministries from '../services/spiritual-gifts/assets/ministries.json';
import rockCategories from '../services/spiritual-gifts/assets/rock_categories.json';

const lowestScore = 0;
const topScorePerCategory = 28;
const medianScore = 28;
const meanScore = 2;
const standardDeviationPerQuestion = 1.414;
const standardDevitionPerCategory = 3.74;
const totalStandardDeviation = 9.17;
const totalPointsAvailable = 168;

@Component({
  selector: 'app-spiritual-gifts-submissions',
  templateUrl: './spiritual-gifts-submissions.component.html',
  styleUrls: ['./spiritual-gifts-submissions.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule]
})
export class SpiritualGiftsSubmissionsComponent implements OnInit {

  private firebaseService = inject(FirebaseService);
  private sharedService = inject(SharedService);

  submissions: AllTestResults[] = [];
  filteredQuestions: AllTestResults[] = [];
  ministries: MinistryArea[] = Ministries;

  inputData = '';

  layout = 'table';

  constructor() {}

  ngOnInit() {
    console.log(this.submissions);
    this.getSubmissions();
  }

  getSubmissions() {
    this.firebaseService.getData().subscribe(async (res) => {
      this.submissions = res as AllTestResults[];
      this.submissions.sort((a, b) => {
        return new Date(b.assessment.CompletedDateTime).getTime() - new Date(a.assessment.CompletedDateTime).getTime(); // descending order
      });
      this.submissions.map(submission => this.getMinistryOpportunities(submission));
      this.filteredQuestions = this.sharedService.deepCopy(this.submissions);
      console.log(this.submissions);

      this.getAnalytics();
    });
  }

  getAnalytics() {
    const emails = new Set();
    const connectionGroups = new Set();

    this.submissions.map(s => {
      emails.add(s.person.Email);
      if (s.person.ConnectionGroup !== '0' && s.person.ConnectionGroup !== '-1') {
        connectionGroups.add(s.person.ConnectionGroup);
      }
    });

    const stats = {
      emails: emails.size,
      connectionGroups: connectionGroups.size
    };
  }

  getMinistryOpportunities(submission: AllTestResults) {
    // Get above average gift categories
    const dominantGifts = submission.gifts.filter(g => g.key === 'Dominant Gifts').flatMap(g => g.gifts.filter(g => g.TotalScore > rockCategories.find(x => x.Value === g.SpiritualGiftName).mean));
    const categories = dominantGifts.map(c => rockCategories.find(x => x.Value === c.SpiritualGiftName));
    const ministries = Array.from(new Set(categories.flatMap(c => this.ministries.flatMap(m => m.Groups.filter(g => g.Gender.includes(submission.person.Gender) && g.Constructs.includes(c.Id))))));
    submission.ministryPositions = ministries;
  }

  getScore(categories: SpiritualGiftScore[], category: string) {
    return categories.find(c => c.SpiritualGiftName === category).TotalScore;
  }

  getConnectionGroup(submission: AllTestResults) {

    if (submission.person.ConnectionGroup === '0') {
      return 'No Connection Group';
    } else if (submission.person.ConnectionGroup === '-1') {
      return 'Not Listed';
    }

    const connectionGroups = ConnectionGroups.flatMap(g => g.Groups);
    const connectionGroup = connectionGroups.find(g => g.Id === submission.person.ConnectionGroup);

    return connectionGroup ? connectionGroup.Name : 'Unknown';
  }

  filterNames() {
    this.submissions = this.filteredQuestions.filter(s => {
      const name = `${s.person.FirstName} ${s.person.LastName}`;
      if (name.toLowerCase().indexOf(this.inputData.toLowerCase()) > -1) {
        return name;
      } 
    });
  }
    
}